// Ticket AUT-17 — séparation Prénom / Nom sur `User`.
//
// Centralise les DEUX dérivations frontend qui existaient en copies séparées
// avant ce ticket : `firstNameFromFullName()` (web-parent `Home.tsx`, UX-34),
// `CashierHome` (web-admin `Home.tsx`), `StudentsOverview.tsx` — chacune
// réimplémentant "premier mot de `fullName`" faute de champ dédié.
//
// ⚠️ Le repli sur cette heuristique reste NÉCESSAIRE et le restera : un compte
// créé AVANT AUT-17 garde `firstName === null` tant que son titulaire ne l'a pas
// renseigné lui-même (aucun découpage automatique, décision produit du 24/08).
// L'heuristique n'est jamais persistée — seulement affichée.

export interface NamedUser {
  fullName: string;
  firstName?: string | null;
  lastName?: string | null;
}

/** Prénom pour une salutation ("Bonjour, Aïcha"). */
export function greetingFirstName(user: NamedUser): string {
  const first = user.firstName?.trim();
  if (first) return first;
  return user.fullName.trim().split(/\s+/)[0] || user.fullName;
}

/**
 * Initiales d'un utilisateur.
 *
 * Utilise le couple prénom/nom quand il est connu (initiale de chacun) ; sinon
 * retombe sur `fullName` (première et dernière initiale des mots), ce que faisait
 * `initialsFromFullName()` dans web-parent `Home.tsx` avant AUT-17.
 */
export function userInitials(user: NamedUser): string {
  const first = user.firstName?.trim();
  const last = user.lastName?.trim();
  if (first && last) return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();

  const parts = user.fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return `${parts[0]!.charAt(0)}${parts[parts.length - 1]!.charAt(0)}`.toUpperCase();
}
